export enum Roles {
    Admin = 'Admin',
    User = 'User',
    Contractor = 'Contractor',
}

export const ALL_ROLES = [Roles.Admin, Roles.User, Roles.Contractor];

export const ONLY_ADMIN = [Roles.Admin];

export const ONLY_CONTRACTOR = [Roles.Admin, Roles.Contractor];

export const ONLY_USER = [Roles.Admin, Roles.User];
